import { Button, ButtonGroup } from '@mui/material'
import { useState } from 'react'
import { GroupedStatus } from 'shared/models/groupedStatus'

export interface RosterFiltersProps {
    statuses: GroupedStatus[]
    onStatusClick: (statuses: GroupedStatus) => void
    saveFilterKey: string
    initialFilter?: GroupedStatus
}

const RosterFilters: React.FC<RosterFiltersProps> = ({
    statuses,
    onStatusClick,
    saveFilterKey,
    initialFilter = statuses[0],
}) => {
    const updateActiveTabParam = (newValue: GroupedStatus) => {
        const queryParams = new URLSearchParams(window.location.search)
        queryParams.set(saveFilterKey, newValue.status)
        window.history.replaceState(null, '', `?${queryParams.toString()}`)
        onStatusClick(newValue)
    }

    const [selectedStatus, setSelectedStatus] = useState<GroupedStatus>(() => {
        const firstFilter = initialFilter ?? statuses[0]
        updateActiveTabParam(firstFilter)
        return firstFilter
    })

    const handleStatusClick = (status: GroupedStatus) => {
        setSelectedStatus(status)
        updateActiveTabParam(status)
    }

    return (
        <ButtonGroup
            color="primary"
            orientation="horizontal"
            variant="outlined"
        >
            {statuses.map((status) => (
                <Button
                    key={status.status}
                    variant={
                        selectedStatus.status === status.status
                            ? 'contained'
                            : 'outlined'
                    }
                    onClick={() => handleStatusClick(status)}
                >
                    {status.label ?? status.status}
                </Button>
            ))}
        </ButtonGroup>
    )
}

export default RosterFilters
